import { render, staticRenderFns } from "./UserActionActivateDialog.vue?vue&type=template&id=5f43273a&"
import script from "./UserActionActivateDialog.vue?vue&type=script&lang=js&"
export * from "./UserActionActivateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports